import type { DataTableDesignTokens, DataTableTokenSections } from '@openng/optimus-ui-themes/types/datatable';

export const header: DataTableTokenSections.Header = {
	background: '{primary.50}',
	color: '{primary.400}',
};

export const headerCell: DataTableTokenSections.HeaderCell = {
	background: '{primary.50}',
	color: '{primary.700}',
	padding: '0.5rem 0.25rem',
};

export const columnTitle: DataTableTokenSections.ColumnTitle = {
	fontWeight: '500',
};

export const row: DataTableTokenSections.Row = {
	color: '{text.color}',
};

export const bodyCell: DataTableTokenSections.BodyCell = {
	padding: '0.5rem 0.25rem',
};

export const footerCell: DataTableTokenSections.FooterCell = {
	color: '{text.color}',
};

export const footer: DataTableTokenSections.Footer = {
	color: '{surface.800}',
	borderWidth: '1px',
};

export const paginatorTop: DataTableTokenSections.PaginatorTop = {
	borderWidth: '1px',
};

export const paginatorBottom: DataTableTokenSections.PaginatorBottom = {
	borderWidth: '1px',
};

export default {
	header,
	headerCell,
	columnTitle,
	row,
	bodyCell,
	footerCell,
	footer,
	paginatorTop,
	paginatorBottom,
} satisfies DataTableDesignTokens;
